<div class="modal-overlay">
    <div class="modal-container">
        <!-- Header -->
        <div class="modal-header">
            <div class="header-title">
                <div class="title-icon">
                    <i class="material-symbols-rounded">compare_arrows</i>
                </div>
                <div>
                    <h2>Compare Bills</h2>
                    <p>Side-by-side Analysis</p>
                </div>
            </div>
            <button (click)="close.emit()" class="close-btn">
                <i class="material-symbols-rounded">close</i>
            </button>
        </div>

        <!-- Content -->
        <div class="modal-content">
            <!-- Comparison Grid Header -->
            <div class="comparison-header">
                <div class="field-header"></div>
                <div class="bill-header">
                    <div class="bill-label bill-a">Bill A</div>
                    <div class="bill-info">
                        <h3 [title]="billA.file.name">{{ billA.file.name }}</h3>
                        <span class="status-badge">{{ billA.status }}</span>
                    </div>
                </div>
                <div class="bill-header">
                    <div class="bill-label bill-b">Bill B</div>
                    <div class="bill-info">
                        <h3 [title]="billB.file.name">{{ billB.file.name }}</h3>
                        <span class="status-badge">{{ billB.status }}</span>
                    </div>
                </div>
            </div>

            <!-- General Info -->
            <div class="comparison-section">
                <div class="section-label">
                    <span>General Information</span>
                </div>
                <div class="section-table">
                    <div class="comparison-row">
                        <div class="cell-label">Provider</div>
                        <div class="cell-value">{{ dataA.providerName || '-' }}</div>
                        <div class="cell-value">{{ dataB.providerName || '-' }}</div>
                    </div>
                    <div class="comparison-row">
                        <div class="cell-label">Legal Entity</div>
                        <div class="cell-value">{{ dataA.legalEntity || '-' }}</div>
                        <div class="cell-value">{{ dataB.legalEntity || '-' }}</div>
                    </div>
                    <div class="comparison-row" [class.different]="accountNumberDifferent">
                        <div class="cell-label">{{ accountNumberLabel }}</div>
                        <div class="cell-value" [class.highlight]="accountNumberDifferent">{{ dataA.utilityAccountNumber || '-' }}</div>
                        <div class="cell-value" [class.highlight]="accountNumberDifferent">{{ dataB.utilityAccountNumber || '-' }}</div>
                    </div>
                    <div class="comparison-row">
                        <div class="cell-label">{{ secondaryAccountNumberLabel }}</div>
                        <div class="cell-value">{{ dataA.utilityAccountNumber2 || '-' }}</div>
                        <div class="cell-value">{{ dataB.utilityAccountNumber2 || '-' }}</div>
                    </div>
                </div>
            </div>

            <!-- Dates -->
            <div class="comparison-section">
                <div class="section-label">
                    <span>Billing Period</span>
                </div>
                <div class="section-table">
                    <div class="comparison-row">
                        <div class="cell-label">Start Date</div>
                        <div class="cell-value">{{ startDateA }}</div>
                        <div class="cell-value">{{ startDateB }}</div>
                    </div>
                    <div class="comparison-row">
                        <div class="cell-label">End Date</div>
                        <div class="cell-value">{{ endDateA }}</div>
                        <div class="cell-value">{{ endDateB }}</div>
                    </div>
                </div>
            </div>

            <!-- Usage & Financials -->
            <div class="comparison-section">
                <div class="section-label">
                    <span>Usage & Financials</span>
                </div>
                <div class="section-table">
                    <div class="comparison-row">
                        <div class="cell-label">Usage Amount</div>
                        <div class="cell-value">{{ dataA.usageAmount || '-' }}</div>
                        <div class="cell-value">{{ dataB.usageAmount || '-' }}</div>
                    </div>
                    <div class="comparison-row">
                        <div class="cell-label">Usage Unit</div>
                        <div class="cell-value">{{ dataA.usageUnit || '-' }}</div>
                        <div class="cell-value">{{ dataB.usageUnit || '-' }}</div>
                    </div>
                    <div class="comparison-row" [class.different]="totalAmountDifferent">
                        <div class="cell-label">Total Amount</div>
                        <div class="cell-value" [class.highlight]="totalAmountDifferent">{{ totalAmountA }}</div>
                        <div class="cell-value" [class.highlight]="totalAmountDifferent">{{ totalAmountB }}</div>
                    </div>
                    <div class="comparison-row">
                        <div class="cell-label">Supply Charges</div>
                        <div class="cell-value">{{ supplyChargesA }}</div>
                        <div class="cell-value">{{ supplyChargesB }}</div>
                    </div>
                    <div class="comparison-row">
                        <div class="cell-label">Distribution Charges</div>
                        <div class="cell-value">{{ distributionChargesA }}</div>
                        <div class="cell-value">{{ distributionChargesB }}</div>
                    </div>
                    <div class="comparison-row">
                        <div class="cell-label">Confidence Score</div>
                        <div class="cell-value">{{ confidenceA }}</div>
                        <div class="cell-value">{{ confidenceB }}</div>
                    </div>
                </div>
            </div>

            <!-- Address -->
            <div class="comparison-section">
                <div class="section-label">
                    <span>Service Address</span>
                </div>
                <div class="section-table">
                    <div class="comparison-row">
                        <div class="cell-label">Street 1</div>
                        <div class="cell-value">{{ dataA.serviceAddressStreet1 || '-' }}</div>
                        <div class="cell-value">{{ dataB.serviceAddressStreet1 || '-' }}</div>
                    </div>
                    <div class="comparison-row">
                        <div class="cell-label">City</div>
                        <div class="cell-value">{{ dataA.serviceAddressCity || '-' }}</div>
                        <div class="cell-value">{{ dataB.serviceAddressCity || '-' }}</div>
                    </div>
                    <div class="comparison-row">
                        <div class="cell-label">State</div>
                        <div class="cell-value">{{ dataA.serviceAddressState || '-' }}</div>
                        <div class="cell-value">{{ dataB.serviceAddressState || '-' }}</div>
                    </div>
                    <div class="comparison-row">
                        <div class="cell-label">Zip</div>
                        <div class="cell-value">{{ dataA.serviceAddressZip || '-' }}</div>
                        <div class="cell-value">{{ dataB.serviceAddressZip || '-' }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
